import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  
  IconButton,
  Button,
  Typography,
  Dialog,
  useMediaQuery,
  Theme,
  Grid,
  Card,
  
  CardActions,
  DialogTitle,
  DialogContent,
  
  // Alert as AlertSnackbar
} from '@mui/material';
// import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
// import AddIcon from '@mui/icons-material/Add';
// import VisibilityIcon from '@mui/icons-material/Visibility';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { fetchApi } from '../services/api';
import { format } from 'date-fns';
import SideMenu from '../components/SideMenu';
import ConfirmDialog from '../components/ConfirmDialog';
import AlertSnackbar from '../components/AlertSnackbar';
import Tooltip from '@mui/material/Tooltip';
import EmailShareDialog from '../components/EmailShareDialog';
// import { emailTemplate } from '../templates/emailTemplate';
// import { useUser } from '../contexts/UserContext';
// import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
// import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
// import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
// import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
// import PaidOutlined from '@mui/icons-material/PaidOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import PublicOutlined from '@mui/icons-material/PublicOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { alpha } from '@mui/material/styles';

interface ApiTableResponse {
  table: Itinerary[];
}

interface ApiSharedCompanyResponse {
  table: SharedCompany[];
}
interface SharedCompany {
  회사명: string;
  담당자명: string;
  이메일: string;
  전화번호: string;
  기본주소: string;
  상세주소: string;
}
type Itinerary = {
  일정번호: number;
  일정명: string;
  상품가: number;
  유저명: string;
  등록일시: string;
  공유: boolean;
  엑셀파일경로: string;
  내용: string;
  즐겨찾기: boolean;
  방문도시?: string;
  업체번호: string;
  조회수: number;
  공유수: number;
} & {
  [key: string]: string | number | boolean;
};
interface LandInfo {
  사업자등록번호유무: boolean;
  사업자등록번호: string;
  대표자: string;
  대표전화: string;
  대표이메일: string;
  우편번호: string;
  기본주소: string;
  상세주소: string;
  업체번호: number;
  업체명: string;
  통신판매업신고번호: string;
  관광사업자번호: string;
  영업보증보험료: number;
  기획여행보증보험료: number;
  회사로고: string;
}

const drawerWidth = 240;

interface SortConfig {
  key: string;
  direction: 'asc' | 'desc' | null;
}

const FavoritePage: React.FC = () => {
  // const { userInfo, companyInfo } = useUser();
  const navigate = useNavigate();
  const [itineraries, setItineraries] = useState<Itinerary[]>([]);
  // const [emailList, setEmailList] = useState('');
  // const [messageSubject, setMessageSubject] = useState('');
  // const [messageOption, setMessageOption] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedItinerary, setSelectedItinerary] = useState<Itinerary | null>(null);
  // const [openDialog, setOpenDialog] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    key: '',
    direction: null
  });
  // const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [popupContent, setPopupContent] = useState<any | null>(null);
  const [open, setOpen] = useState(false);
  const [hoveredItinerary, setHoveredItinerary] = useState<number | null>(null);
  // const [companyNo, setCompanyNo] = useState<string | null>(null);
  // const [emailTo, setEmailTo] = useState('');
  // const [emailContent, setEmailContent] = useState('');
  // const [isSending, setIsSending] = useState(false);
  // const [isHovered, setIsHovered] = useState(false);
  const [sharedCompanies, setSharedCompanies] = useState<SharedCompany[]>([]);
  const [isShareListOpen, setIsShareListOpen] = useState(false);

  const [companyInfoDialog, setCompanyInfoDialog] = useState(false);
  const [companyInfoData, setCompanyInfoData] = useState<LandInfo | null>(null);
  const [companyIntroduction, setCompanyIntroduction] = useState<string>('');

  const [selectedItineraryNo, setSelectedItineraryNo] = useState<number | null>(null);
  const [confirmDialog, setConfirmDialog] = useState<{
    open: boolean;
    message: string;
    onConfirm: () => void;
  }>({
    open: false,
    message: '',
    onConfirm: () => { },
  });
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'info' | 'warning';
  }>({
    open: false,
    message: '',
    severity: 'info'
  });
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleClose = () => setOpen(false);
  // const handleCloseShareDialog = () => setShareDialogOpen(false);
  const fetchItineraries = async (keyword?: string) => {
    try {
      const CompanyNo = localStorage.getItem('CompanyNo');
      if (!CompanyNo) {
        throw new Error('Company ID not found');
      }

      const procedureName = 'ITN_S_간편일정';
      const postData = [
        { "컬럼명": "@업체번호", "값": CompanyNo },
        { "컬럼명": "@즐겨찾기", "값": 1 },
      ];

      if (keyword) {
        postData.push({ "컬럼명": "@검색어", "값": keyword });
      }

      const response = await fetchApi<ApiTableResponse>(procedureName, postData);

      if (response.data && response.data.table) {
        setItineraries(response.data.table);
      } else {
        setItineraries([]);
      }
    } catch (error) {
      console.error('Failed to fetch itineraries:', error);
      setItineraries([]);
    }
  };

  useEffect(() => {
    fetchItineraries();
  }, []);

  // const handleSearch = () => {
  //   fetchItineraries(searchKeyword);
  // };

  // const handleKeyPress = (event: React.KeyboardEvent) => {
  //   if (event.key === 'Enter') {
  //     handleSearch();
  //   }
  // };

  const handleEdit = async (itinerary: Itinerary) => {
    const postData = [
      { "컬럼명": "@일정번호", "값": itinerary.일정번호.toString() }
    ];

    const response = await fetchApi<ApiTableResponse>("ITN_S_일정표", postData);

    if (response.data && response.data.table) {

      itinerary.내용 = response.data.table[0].내용;
      console.log(itinerary);
      navigate('/itinerary-upload', { state: { itinerary } });
    }

  };


  const handleDelete = async (itinerary: Itinerary) => {
    setConfirmDialog({
      open: true,
      message: '일정표를 휴지통으로 보낼까요?',
      onConfirm: async () => {
        try {
          const postData = [
            { "컬럼명": "@일정번호", "값": itinerary.일정번호.toString() },
            { "컬럼명": "@즐겨찾기", "값": -1 }
          ];

          await fetchApi("ITN_T_간편일정즐겨찾기", postData);
          setItineraries(prevItineraries =>
            prevItineraries.filter(item => item.일정번호 !== itinerary.일정번호)
          );
          setSnackbar({
            open: true,
            message: '휴지통으로 이동되었습니다.',
            severity: 'success'
          });
        } catch (error) {
          console.error('Failed to move to trash:', error);
          setSnackbar({
            open: true,
            message: '휴지통 이동 중 오류가 발생했습니다.',
            severity: 'error'
          });
        }
        setConfirmDialog({ ...confirmDialog, open: false });
      }
    });
  };

  const handleOpen = async (itinerary: Itinerary) => {
    try {
      const postData = [
        { "컬럼명": "@일정번호", "값": itinerary.일정번호.toString() }
      ];
      //  공유여부에 값이 들어가야  조회수 + 1 기록 (자기 상품 조회수는 추가 안되게)
      console.log(itinerary.업체번호, localStorage.getItem('CompanyNo'))
      if (itinerary.업체번호 !== localStorage.getItem('CompanyNo')) {
        postData.push({ "컬럼명": "@공유여부", "값": "0" });
      }
      const response = await fetchApi<ApiTableResponse>("ITN_S_일정표", postData);

      if (response.data && response.data.table) {
        setPopupContent(response.data.table[0]);

      }

      setOpen(true);
    } catch (error) {
      console.error('Failed to fetch itinerary detail:', error);
      setPopupContent(itinerary);
      setOpen(true);
    }
  };
  const handleNewOpen = async (itinerary: Itinerary) => {
    // const width = 1600;
    // const height = 960;
    // const left = (window.screen.width - width) / 2;
    // const top = (window.screen.height - height) / 2;
    // const previewUrl = `${window.location.origin}/preview/${itinerary.일정번호}`;
    // window.open(
    //   previewUrl,
    //   '_blank',
    //   `width=${width},height=${height},top=${top},left=${left},location=no,toolbar=no,resizable=no`
    // );
    const previewUrl = `${window.location.origin}/preview/${itinerary.일정번호}`;
    window.open(previewUrl, '_blank');
  }
  const handleShare = (itinerary: Itinerary) => {
    const previewUrl = `${window.location.origin}/preview/${itinerary.일정번호}`;
    navigator.clipboard.writeText(previewUrl);
    setSnackbar({
      open: true,
      message: '공유 링크가 클립보드에 복사되었습니다.',
      severity: 'success'
    });
  };
  const handleCloseEmailDialog = () => {
    setEmailDialogOpen(false);
    setSelectedItinerary(null);
  };

  const handleOpenEmailDialog = (itinerary: Itinerary) => {
    setSelectedItinerary(itinerary);
    setEmailDialogOpen(true);
  };

  const handleShareListClick = async (일정번호: number) => {

    setSelectedItineraryNo(일정번호);
    try {
      const postData = [
        { "컬럼명": "일정번호", "값": 일정번호.toString() }
      ];
      const response = await fetchApi<ApiSharedCompanyResponse>("ITN_S_공유업체리스트", postData);
      if (response.data.table) {
        setSharedCompanies(response.data.table);
        setIsShareListOpen(true);
      }
    } catch (error) {
      console.error('공유 업체 리스트 조회 실패:', error);
    }
  };
  const ShareListDialog = () => (
    <Dialog
      open={isShareListOpen}
      onClose={() => setIsShareListOpen(false)}
      maxWidth="md"
      fullWidth
      sx={{ px: 3, py: 2 }}
    >
      <DialogTitle sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: 'primary.main',
        color: 'white',
        borderBottom: '1px solid #e0e0e0',
        px: 3, py: 2,
      }}>
        <Typography variant="h6">공유한 업체 리스트</Typography>
        <Button
          onClick={() => setIsShareListOpen(false)}
          size="small"
          sx={{
            bgcolor: 'white',
            color: 'primary.main',
            '&:hover': {
              bgcolor: 'grey.100'
            },
            height: '28px',
            px: 2
          }}
          startIcon={<CloseIcon sx={{ color: 'primary.main' }} />}
        >
          닫기
        </Button>
      </DialogTitle>
      <DialogContent sx={{ mt: 2, minHeight: '50vh', }}>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            '& .MuiTableCell-head': {
              bgcolor: '#f5f5f5',
              fontWeight: 'bold'
            }
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '15%', fontSize: '13px' }}>회사명</TableCell>
                <TableCell sx={{ width: '10%', fontSize: '13px' }}>담당자</TableCell>
                <TableCell sx={{ width: '7%', fontSize: '13px' }}>연락처</TableCell>
                <TableCell sx={{ width: '15%', fontSize: '13px' }}>이메일</TableCell>
                <TableCell sx={{ width: '50%', fontSize: '13px' }}>주소</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sharedCompanies.map((company, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:hover': {
                      bgcolor: '#f5f5f5'
                    }
                  }}
                >
                  <TableCell sx={{ fontSize: '13px' }}>{company.회사명}</TableCell>
                  <TableCell sx={{ fontSize: '13px' }}>{company.담당자명}</TableCell>
                  <TableCell sx={{ fontSize: '13px' }}>{company.전화번호}</TableCell>
                  <TableCell sx={{ fontSize: '13px' }}>{company.이메일}</TableCell>
                  <TableCell sx={{ fontSize: '13px' }}>{`${company.기본주소} ${company.상세주소}`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
  const handleFavorite = async (itinerary: Itinerary) => {
    try {
      const token = localStorage.getItem('token');
      const decodedToken = token ? decodeToken(token) : {};
      const postData = [
        { "컬럼명": "@일정번호", "값": itinerary.일정번호.toString() },
        { "컬럼명": "@업체번호", "값": decodedToken.CompanyNo.toString() },
        { "컬럼명": "@즐겨찾기", "값": Number(!itinerary.즐겨찾기) }
      ];

      await fetchApi("ITN_T_간편일정즐겨찾기", postData);
      // Remove from local state
      setItineraries(prevItineraries => prevItineraries.filter(item => item.일정번호 !== itinerary.일정번호));

    } catch (error) {
      console.error('Failed to toggle favorite:', error);
    }
  };

  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), 'yyyy-MM-dd');
    } catch {
      return dateString;
    }
  };

  const handleSort = (key: string) => {
    let sortKey = key;
    if (key === '등록업체') {
      sortKey = '업체명';
    }

    setSortConfig(prevConfig => ({
      key: sortKey,
      direction: prevConfig.key === sortKey
        ? prevConfig.direction === 'asc'
          ? 'desc'
          : prevConfig.direction === 'desc'
            ? null
            : 'asc'
        : 'asc'
    }));
  };

  const sortedItineraries = React.useMemo(() => {
    if (!sortConfig.direction) return itineraries;

    return [...itineraries].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (sortConfig.key === '상품가' || sortConfig.key === '조회수' || sortConfig.key === '공유수') {
        return sortConfig.direction === 'asc'
          ? Number(aValue) - Number(bValue)
          : Number(bValue) - Number(aValue);
      }

      if (sortConfig.key === '등록일시') {
        return sortConfig.direction === 'asc'
          ? new Date(aValue as string).getTime() - new Date(bValue as string).getTime()
          : new Date(bValue as string).getTime() - new Date(aValue as string).getTime();
      }

      if (typeof aValue === 'boolean') {
        return sortConfig.direction === 'asc'
          ? (aValue ? 1 : -1)
          : (aValue ? -1 : 1);
      }

      return sortConfig.direction === 'asc'
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }, [itineraries, sortConfig]);

  const decodeToken = (token: string) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text;
    const half = Math.floor(maxLength / 2);
    return text.slice(0, half) + '...' + text.slice(-half);
  };

  const handleSnackbarClose = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };
  const handleLandInfo = async (itinerary: Itinerary) => {
    const postData = [{ "컬럼명": "@업체번호", "값": itinerary.업체번호 }];
    const response = await fetchApi<any>('ITN_S_업체세부정보', postData);
    if (response?.data?.table?.[0]) {
      setCompanyInfoData(response.data.table[0]);
      setCompanyIntroduction(response.data.table[0].회사소개);
      setCompanyInfoDialog(true);
    }


  };
  const handleCloseCompanyInfoDialog = () => {
    setCompanyInfoDialog(false);
    setCompanyInfoData(null);
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <SideMenu mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          p: 0
        }}
      >
        <Paper
          elevation={0}
          sx={{
            ...(isMobile ? { p: 1.5, mt: 6 } : { py: 2.1, px: 1.6, m: 1.5, mt: 0 }),
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            height: '62px',
          }}
        >
          <Box sx={{ mb: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <BookmarkIcon sx={{ mr: 1 }} />
              <Typography variant="h6" >
                {isMobile ? '즐겨찾기' : '즐겨찾기'}
              </Typography>
            </Box>
          </Box>
        </Paper>
        {isMobile ? (
          <Grid container spacing={1} sx={{ mt: 0.1 }}>
            {sortedItineraries.length === 0 ? (
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '300px',
                    width: '100%',
                    textAlign: 'center',
                    color: 'text.secondary'
                  }}
                >
                  <Typography variant="body1">
                    현재 즐겨찾기한 항목이 없습니다.<br />
                    일정표 즐겨찾기 버튼을 눌러 관심 있는 일정표를 저장해보세요.
                  </Typography>
                </Box>
              </Grid>
            ) : (
              sortedItineraries.map((itinerary) => (
                <Grid item xs={12} key={itinerary.일정번호}>
                  <Card
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    }}
                  >
                    <Box onClick={() => handleOpen(itinerary)} sx={{ position: 'relative', p: 2, pb: 1 }}>
                      <Typography variant="h6" component="div" sx={{ fontWeight: 600, fontSize: '1.0rem', color: '#1a1a1a', mb: 1 }}>
                        {itinerary.일정명}
                      </Typography>

                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: '0.9rem' }}>
                            {(itinerary.방문도시 as string).split(',').map((city: string, index: number, array: string[]) => {
                              if (index < 4 || (index === 4 && array.length <= 5)) {
                                return (
                                  <Box key={index} sx={{ border: '1px solid #e0e0e0', padding: '4px 6px', borderRadius: '4px', fontSize: '13px', height: '24px', backgroundColor: 'white', display: 'flex', alignItems: 'center' }}>
                                    {city.trim()}
                                  </Box>
                                );
                              } else if (index === 4) {
                                const remainingCount = array.length - 4;
                                return (
                                  <Box key={index} sx={{ border: '1px solid', padding: '4px 6px', borderRadius: '4px', fontSize: '13px', height: '24px', color: 'primary.main', borderColor: 'primary.main', backgroundColor: 'white', display: 'flex', alignItems: 'center' }}>
                                    +{remainingCount}
                                  </Box>
                                );
                              }
                              return null;
                            })}
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                            {itinerary.상품가}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <CardActions
                      sx={{ mt: 'auto', p: 2, pt: 1, display: 'flex', gap: 1, flexWrap: 'nowrap', borderTop: '1px solid', borderColor: 'grey.100', overflowX: 'auto' }}>
                      <IconButton onClick={() => handleNewOpen(itinerary)} size="small" sx={{ height: '41px', width: '41px', backgroundColor: 'white' }}>
                        <EventNoteIcon color='primary' sx={{ fontSize: '20px' }} />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(itinerary)} size="small" sx={{ backgroundColor: 'white' }}>
                        <DeleteOutlineIcon color='primary' sx={{ height: '24px' }} />
                      </IconButton>
                      <IconButton onClick={() => handleShare(itinerary)} size="small" sx={{ backgroundColor: 'white' }}>
                        <ShareOutlinedIcon color='primary' sx={{ height: '24px' }} />
                      </IconButton>
                      <IconButton onClick={() => handleOpenEmailDialog(itinerary)} size="small" sx={{ backgroundColor: 'white' }}>
                        <EmailOutlinedIcon color='primary' sx={{ height: '24px' }} />
                      </IconButton>
                      <IconButton onClick={(e) => { e.stopPropagation(); handleFavorite(itinerary); }} size="small" sx={{ backgroundColor: 'white' }}>
                        {itinerary.즐겨찾기 ? (
                          <BookmarkIcon color='primary' sx={{ fontSize: '24px' }} />
                        ) : (
                          <BookmarkBorderIcon color='primary' sx={{ fontSize: '24px' }} />
                        )}
                      </IconButton>

                      <Box onClick={() => handleLandInfo(itinerary)} sx={{ pr: 1, textAlign: 'right', width: '100%', fontSize: '14px', color: 'primary.main' }}>{itinerary.원본일정번호 ? itinerary.업체명 : ''}</Box>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        ) : (
          <Paper
            elevation={1}
            sx={{
              p: 1.5,
              m: 1.5,
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#fff',
              minHeight: 'calc(100vh - 88px)',
            }}
          >
            <TableContainer component={Paper} elevation={0}>
              {sortedItineraries.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '300px',
                    width: '100%',
                    textAlign: 'center',
                    color: 'text.secondary'
                  }}
                >
                  <Typography variant="body1">
                    현재 즐겨찾기한 항목이 없습니다.<br />
                    일정표 즐겨찾기 버튼을 눌러 관심 있는 일정표를 저장해보세요.
                  </Typography>
                </Box>
              ) : (
                <Table
                  size="small"
                  aria-label="즐겨찾기 일정 목록"
                  sx={{
                    tableLayout: 'fixed',
                    width: '100%',
                    '& .MuiTableCell-root': {
                      padding: '5px',
                      borderBottom: '1px solid rgba(224, 224, 224, 1)',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ height: '42.33px' }}>
                      <TableCell sx={{ cursor: 'pointer', width: '30%' }} onClick={() => handleSort('일정명')}>
                        일정명 {sortConfig.key === '일정명' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell sx={{ width: 450, flex: 'none', cursor: 'pointer' }} className="cities hidden-info" onClick={() => handleSort('방문도시')}>
                        방문도시 {sortConfig.key === '방문도시' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell sx={{ cursor: 'pointer', width: '15%' }} className="hidden-info" onClick={() => handleSort('상품가')}>
                        상품가 {sortConfig.key === '상품가' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell sx={{ cursor: 'pointer', width: '15%' }} className="hidden-info" onClick={() => handleSort('등록업체')}>
                        등록업체 {sortConfig.key === '업체명' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell sx={{ cursor: 'pointer', width: '8%' }} className="hidden-info" onClick={() => handleSort('등록일시')}>
                        등록일시 {sortConfig.key === '등록일시' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell sx={{ cursor: 'pointer', width: '5%' }} className="hidden-info" onClick={() => handleSort('공유')}>
                        공개 {sortConfig.key === '공개' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell sx={{ cursor: 'pointer', width: '5%' }} className="hidden-info" onClick={() => handleSort('조회수')}>
                        조회수 {sortConfig.key === '조회수' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                      <TableCell sx={{ cursor: 'pointer', width: '5%' }} className="hidden-info" onClick={() => handleSort('공유수')}>
                        공유수 {sortConfig.key === '공유수' && (sortConfig.direction === 'asc' ? '↑' : sortConfig.direction === 'desc' ? '↓' : '')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedItineraries.map((itinerary) => (
                      <TableRow
                        hover
                        sx={{
                          height: '52px',
                          position: 'relative',
                          '&:hover': {
                            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                            outline: (theme) => `1px solid ${theme.palette.primary.main}`,
                            '& .MuiTableCell-root': {
                              backgroundColor: 'transparent',
                              color: 'inherit',
                            },
                            '& .MuiIconButton-root': {
                              backgroundColor: 'white',
                              '&:hover': {
                                backgroundColor: 'grey.100',
                              }
                            },
                            '& .hidden-info': {
                              color: 'transparent',
                              '& > *': {
                                visibility: 'hidden',
                              },
                            },
                            '& .management-icons': {
                              display: 'flex',
                              visibility: 'visible',
                              height: '52px',
                              gap: '16px',
                            },
                            '& .cities': {
                              display: 'none',
                            },
                          },
                          '& .management-icons': {
                            display: 'none',
                            visibility: 'hidden',
                          }
                        }}
                      >
                        <TableCell onClick={() => handleOpen(itinerary)} style={{ cursor: 'pointer' }}>
                          {itinerary.일정명}
                        </TableCell>
                        <TableCell sx={{ display: 'flex', gap: '5px', height: '44px', mt: '8px' }} className="cities hidden-info">
                          {(itinerary.방문도시 as string).split(',').map((city: string, index: number, array: string[]) => {
                            if (index < 4 || (index === 4 && array.length <= 5)) {
                              return (
                                <Box key={index} sx={{ border: '1px solid #e0e0e0', padding: '4px 6px', borderRadius: '4px', fontSize: '13px', height: '24px', backgroundColor: 'white', display: 'flex', alignItems: 'center' }}>
                                  {city.trim()}
                                </Box>
                              );
                            } else if (index === 4) {
                              const remainingCount = array.length - 4;
                              return (
                                <Box key={index} sx={{ border: '1px solid', padding: '4px 6px', borderRadius: '4px', fontSize: '13px', height: '24px', color: 'primary.main', borderColor: 'primary.main', backgroundColor: 'white', display: 'flex', alignItems: 'center' }}>
                                  +{remainingCount}
                                </Box>
                              );
                            }
                            return null;
                          })}
                        </TableCell>

                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px' }} className="management-icons">
                          <Tooltip title="일정표보기" leaveDelay={0} disableInteractive >
                            <IconButton onClick={() => handleNewOpen(itinerary)} size="small" sx={{ height: '41px', width: '41px', backgroundColor: 'white' ,
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  }}}>
                              <EventNoteIcon color='primary' sx={{ fontSize: '20px' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="다운로드">
                            <IconButton component="a" href={itinerary.엑셀파일경로} target="_blank" rel="noopener noreferrer" sx={{ height: '41px', width: '41px', backgroundColor: 'white',
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  } }}>
                              <CloudDownloadOutlinedIcon color='primary' sx={{ height: '20px' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="수정" leaveDelay={0} disableInteractive>
                            <IconButton onClick={() => handleEdit(itinerary)} size="small" sx={{ height: '41px', width: '41px', backgroundColor: 'white',
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  } }}>
                              <BorderColorOutlinedIcon color='primary' sx={{ height: '20px' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="휴지통으로 이동">
                            <IconButton onClick={() => handleDelete(itinerary)} size="small" sx={{ height: '41px', width: '41px', backgroundColor: 'white',
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  } }}>
                              <DeleteOutlineIcon color='primary' sx={{ height: '20px' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="공유 링크 복사">
                            <IconButton onClick={() => handleShare(itinerary)} size="small" sx={{ height: '41px', width: '41px', backgroundColor: 'white',
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  } }}>
                              <ShareOutlinedIcon color='primary' sx={{ height: '20px' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="이메일 전송">
                            <IconButton onClick={() => handleOpenEmailDialog(itinerary)} size="small" sx={{ height: '41px', width: '41px', backgroundColor: 'white',
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  } }}>
                              <EmailOutlinedIcon color='primary' sx={{ height: '20px' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="즐겨찾기">
                            <IconButton onClick={(e) => { e.stopPropagation(); handleFavorite(itinerary); }} size="small" sx={{ height: '41px', width: '41px', backgroundColor: 'white' ,
                                  boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                  transition: 'all 0.1s ease-in-out',
                                  '&:hover': {
                                    backgroundColor: 'white !important',
                                    transform: 'translate(-0.5px, -0.5px)',
                                    boxShadow: '2px 2px 4px rgba(0,0,0,0.4)',
                                  }}}>
                              {itinerary.즐겨찾기 ? (
                                <BookmarkIcon color='primary' sx={{ fontSize: '20px' }} />
                              ) : (
                                <BookmarkBorderIcon color='primary' sx={{ fontSize: '20px' }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        </Box>
                        <TableCell>{truncateText(itinerary.상품가.toString(), 20)}</TableCell>
                        {itinerary.업체번호 !== localStorage.getItem('CompanyNo') ? (
                          <TableCell>
                            <Typography
                              onClick={() => handleLandInfo(itinerary)}
                              sx={{
                                fontSize: '14px',
                                color: 'primary.main',
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}>
                              {itinerary.업체명}
                            </Typography>
                          </TableCell>
                        ) : (
                          <TableCell>
                            {itinerary.업체명}
                          </TableCell>
                        )}
                        <TableCell className="hidden-info1" sx={{ textAlign: 'center' }}>{formatDate(itinerary.등록일시)}</TableCell>
                        <TableCell className="hidden-info1" sx={{ textAlign: 'center' }}>
                          <IconButton size="small" >
                            {itinerary.공유 === true ? (
                              <PublicOutlined sx={{ fontSize: '18px', color: 'grey.700' }} />
                            ) : (
                              <LockOutlined sx={{ fontSize: '18px', color: 'grey.700' }} />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell className="hidden-info1" sx={{ textAlign: 'center' }}>{itinerary.조회수}</TableCell>
                        <TableCell align="center">
                          {itinerary.공유수 > 0 ? (
                            <Typography
                              onClick={() => handleShareListClick(itinerary.일정번호)}
                              sx={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: 'primary.main',
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}>
                              {itinerary.공유수}
                            </Typography>
                          ) : (
                            itinerary.공유수
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Paper>
        )}      <EmailShareDialog
          open={emailDialogOpen}
          onClose={handleCloseEmailDialog}
          selectedItinerary={selectedItinerary}
          onSuccess={() => {
            setSnackbar({
              open: true,
              message: '이메일이 성공적으로 전송되었습니다.',
              severity: 'success'
            });
          }}
          onError={(error) => {
            setSnackbar({
              open: true,
              message: error,
              severity: 'error'
            });
          }}
        />

        <ConfirmDialog
          open={confirmDialog.open}
          message={confirmDialog.message}
          onConfirm={confirmDialog.onConfirm}
          onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        />
        <AlertSnackbar
          open={snackbar.open}
          message={snackbar.message}
          severity={snackbar.severity}
          onClose={handleSnackbarClose}
        />
      </Box>
      {/* 다이얼로그들 */}
      <Dialog
        open={companyInfoDialog}
        onClose={handleCloseCompanyInfoDialog}
        maxWidth="md"
        fullWidth
      >
        {companyInfoData && (
          <>
            <DialogTitle sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              bgcolor: 'primary.main',
              color: 'white',
              borderBottom: '1px solid #e0e0e0',
              px: 3
            }}>
              <Typography variant="h6" sx={{ pl: 1 }}>{companyInfoData.업체명}</Typography>
              <Button
                onClick={handleCloseCompanyInfoDialog}
                size="small"
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  '&:hover': {
                    bgcolor: 'grey.100'
                  },
                  height: '28px',
                }}
                startIcon={<CloseIcon sx={{ color: 'primary.main' }} />}
              >
                닫기
              </Button>
            </DialogTitle>
            <DialogContent sx={{ p: 1 }}>
              <Box sx={{
                p: 2,
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' }
              }}>
                <Box sx={{
                  width: { xs: '100%', sm: '45%' },
                  mb: { xs: 2, sm: 0 }
                }}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>대표자명</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.대표자}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>대표전화</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.대표전화}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>이메일</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.대표이메일}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>주소</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.기본주소 + ' ' + companyInfoData.상세주소}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>영업보증보험료</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.영업보증보험료}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>기획여행보증보험료</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.기획여행보증보험료}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>통신판매신고업</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.통신판매업신고번호}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        '&:hover': { bgcolor: 'grey.50' }
                      }}>
                        <Box sx={{ width: '40%', p: 1.5, bgcolor: 'grey.100' }}>
                          <Typography sx={{ fontSize: '14px' }}>관광사업자번호</Typography>
                        </Box>
                        <Box sx={{ width: '60%', p: 1.5 }}>
                          <Typography sx={{ fontSize: '14px' }}>{companyInfoData.관광사업자번호}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{
                  width: { xs: '100%', sm: '55%' },
                  pl: { xs: 0, sm: 2 }
                }}>
                  <Box sx={{
                    height: '100%',
                    p: 2,
                    bgcolor: 'grey.50',
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'grey.300'
                  }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold', mb: 1 }}>회사소개</Typography>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        whiteSpace: 'pre-wrap',
                        overflowY: 'auto',
                        maxHeight: { xs: '200px', sm: 'calc(100% - 30px)' }
                      }}
                    >
                      {companyIntroduction}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </DialogContent>
          </>
        )}
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        fullScreen={useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))}
        sx={{
          '& .MuiDialog-paper': {
            margin: { xs: 0, sm: 2 },
            // maxHeight: { xs: '100vh', sm: 'calc(100vh - 64px)' },
            maxHeight: '100vh',
            borderRadius: { xs: 0, sm: 1 }
          }
        }}
      >
        <Box sx={{ height: '95vh', position: 'relative', overflow: 'auto' }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey.700',
              bgcolor: 'white',
              '&:hover': {
                bgcolor: 'grey.100'
              },
              zIndex: 1,
              display: { xs: 'flex', sm: 'none' }
            }}
          >
            <CloseIcon />
          </IconButton>
          <iframe
            srcDoc={popupContent?.내용 || ''}
            style={{ width: '100%', height: `calc( 100% - 8px)`, border: 'none' }}
            title="일정 내용"
          />
        </Box>
      </Dialog>
      <ShareListDialog />
      <AlertSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
    </Box >

  );
};

export default FavoritePage;

